import { goto } from "$app/navigation";
import { parseUrl } from "$lib/utils/helpers";

/**
 * Transforms a hex color code into an rgba color value
 * @param hexColor - The hex color code (with or without #)
 * @param opacity - The opacity value
 * @returns The rgba color string
 */
export function transformHexToRgba(hexColor: string, opacity: string): string {
  // Remove the hash if present
  const hex = hexColor.replace("#", "");

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Return rgba string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

/**
 * Generates a random alphanumeric string
 * @param length - The length of the random string (default: 12)
 * @returns A random alphanumeric string
 */
export function generateRandomString(length: number = 12): string {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}

/**
 * Function to open an internal or external link
 * @param link - A link object
 */
export function openLink(link: any) {
  const url = parseUrl(link);
  if (!url) return;

  // Open external URLs in a new tab, and internal URLs internally
  const isExternalUrl = link.linktype === "url";
  isExternalUrl ? window.open(url, "_blank") : goto(url);
}
